import React from "react";
import {Route, Switch} from "react-router-dom";
import Login from "./containers/Login";
import NotFound from "./containers/NotFound";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import Dashboard from "./containers/Dashboard";

export default function Routes() {

    return (
        <Switch>
            <UnauthenticatedRoute exact path="/">
                <Login/>
            </UnauthenticatedRoute>
            <AuthenticatedRoute exact path="/dashboard">
                <Dashboard/>
            </AuthenticatedRoute>
            <Route>
                <NotFound/>
            </Route>
        </Switch>
    );
}
